/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Equation_HintInputs */

const en_reading_class_equation_hint = /** @type {(inputs: Reading_Class_Equation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equations and formulas`)
};

const es_reading_class_equation_hint = /** @type {(inputs: Reading_Class_Equation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecuaciones y fórmulas`)
};

/**
* | output |
* | --- |
* | "Equations and formulas" |
*
* @param {Reading_Class_Equation_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_equation_hint = /** @type {((inputs?: Reading_Class_Equation_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Equation_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_equation_hint(inputs)
	return en_reading_class_equation_hint(inputs)
});